// extracted by mini-css-extract-plugin
export var grid = "_10-0";
export var span1 = "_10-2";
export var span10 = "_10-b";
export var span10L = "_10-z";
export var span10M = "_10-n";
export var span10Xl = "_10-1b";
export var span11 = "_10-c";
export var span11L = "_10-10";
export var span11M = "_10-o";
export var span11Xl = "_10-1c";
export var span12 = "_10-d";
export var span12L = "_10-11";
export var span12M = "_10-p";
export var span12Xl = "_10-1d";
export var span1L = "_10-q";
export var span1M = "_10-e";
export var span1Xl = "_10-12";
export var span2 = "_10-3";
export var span2L = "_10-r";
export var span2M = "_10-f";
export var span2Xl = "_10-13";
export var span3 = "_10-4";
export var span3L = "_10-s";
export var span3M = "_10-g";
export var span3Xl = "_10-14";
export var span4 = "_10-5";
export var span4L = "_10-t";
export var span4M = "_10-h";
export var span4Xl = "_10-15";
export var span5 = "_10-6";
export var span5L = "_10-u";
export var span5M = "_10-i";
export var span5Xl = "_10-16";
export var span6 = "_10-7";
export var span6L = "_10-v";
export var span6M = "_10-j";
export var span6Xl = "_10-17";
export var span7 = "_10-8";
export var span7L = "_10-w";
export var span7M = "_10-k";
export var span7Xl = "_10-18";
export var span8 = "_10-9";
export var span8L = "_10-x";
export var span8M = "_10-l";
export var span8Xl = "_10-19";
export var span9 = "_10-a";
export var span9L = "_10-y";
export var span9M = "_10-m";
export var span9Xl = "_10-1a";
export var stretch = "_10-1";